import styled from 'styled-components';
import { Heading } from '@alefeducation/ui-elements-library-core';
import {
  CREATE_NEW_ROLE,
  EDIT_ROLE,
  FILL_FORM_TO_ADD_ROLE,
  VIEW_ROLE,
} from '../../../utils/constants';

const StyledHeader = styled.div`
  padding: 24px 24px 16px 24px;
  margin-bottom: 1px;
  border-bottom: 1px solid ${({ theme }: any) => theme.colors.primary[10]};
`;

const StyledTitle = styled(Heading)`
  margin-bottom: 16px;
`;

type Props = {
  isEdit?: boolean;
  isViewOnlyRole?: boolean;
};

const Header = ({ isEdit, isViewOnlyRole }: Props) => {
  const frameTitle = () => {
    if (isEdit) {
      if (isViewOnlyRole) {
        return VIEW_ROLE;
      } else {
        return EDIT_ROLE;
      }
    } else {
      return CREATE_NEW_ROLE;
    }
  };

  return (
    <StyledHeader data-testid="create-role-header">
      <StyledTitle variant="heading-medium">{frameTitle()}</StyledTitle>
      {!isViewOnlyRole && (
        <Heading variant="heading-small" weight="light" color="primary.60">
          {FILL_FORM_TO_ADD_ROLE}
        </Heading>
      )}
    </StyledHeader>
  );
};

export default Header;
